import React from 'react';
import Image from '../../utils/Image/Image';
import { BundleContainer, BundleItem } from './Bundle.styles';
import { formatPrice } from '../../../utils/util';
import { DotText, MediaFooter, TimeText } from '../../../pages/manual/ChatPage/ChatPage.styles';
import { format } from 'date-fns';

const Bundle = ({ media, item, text }) => {
  return (
    <BundleContainer>
      {media.map(({ thumbnailUrl, type }, index) => (
        <BundleItem key={index}>
          <Image src={thumbnailUrl} alt={`Bundle media ${index + 1}`} />
        </BundleItem>
      ))}
      <MediaFooter $role={'INFLUENCER'}>
        {text && (
          <>
            <TimeText $role={'INFLUENCER'}>{`$${formatPrice(item.cost)} ${text}`}</TimeText>
            <DotText>•</DotText>
          </>
        )}
        {!!item.cost && !text && (
          <>
            <TimeText $role={'INFLUENCER'} $purchased={item.purchased}>
              {`$${formatPrice(item.cost)} ${item.purchased ? 'paid' : 'not paid yet'}`}
            </TimeText>
            <DotText>•</DotText>
          </>
        )}
        <TimeText $role={'INFLUENCER'}>{format(item.timestamp, 'HH:mm')}</TimeText>
      </MediaFooter>
    </BundleContainer>
  );
};

export default Bundle;
